import type { JSX } from "react";

export interface ErrorStateProps {
  title: string;
  body: string;
  retryLabel: string;
  onRetry: () => void;
}

export function ErrorState({ title, body, retryLabel, onRetry }: ErrorStateProps): JSX.Element {
  return (
    <div
      role="alert"
      aria-live="assertive"
      data-testid="error-state"
      className="flex flex-col items-center gap-3 rounded-[var(--radius-card)] border border-[var(--color-rust)] bg-[var(--color-rust)]/10 p-6 text-center"
    >
      <h3 className="font-subhead text-sm uppercase tracking-[0.06em] text-[var(--color-blood)]">
        {title}
      </h3>
      <p className="font-sans text-sm text-[var(--color-ink)]">{body}</p>
      <button
        type="button"
        onClick={onRetry}
        data-testid="error-retry"
        className="border border-[var(--color-line-strong)] px-4 py-2 font-subhead text-sm uppercase tracking-[0.06em] text-[var(--color-ink)] hover:bg-[var(--color-slab-2)]"
      >
        {retryLabel}
      </button>
    </div>
  );
}
